
import { MapTo } from '@adobe/aem-react-editable-components';
import ReviewsMultiProduct, { ReviewsMultiProductEditConfig } from './ReviewsMultiProduct';

export default MapTo('cob-corp-acquisition/components/creditonebank/reviews-multi-product')(ReviewsMultiProduct, ReviewsMultiProductEditConfig);
        